<template>
  <div class="goods-box my-form">

    <div class="registered">
        <van-form @submit="onSubmit" show-error :show-error-message="false">
          <div class="cell-box">
            <van-field
                v-model="form.Username"
                name="姓名"
                label="姓名"
                placeholder="请输入姓名"
                required
                :rules="[{ required: true, message: '请填写用户名' }]"
            />
          </div>
          <div class="cell-box">
            <van-field
                v-model="form.Phone"
                type="number"
                name="pattern"
                label="手机"
                maxlength="11"
                placeholder="请输入手机"
                required
                :rules="[{ pattern, message: '请填写手机' }]"
            />
          </div>
          <div class="cell-box">
            <van-field
                v-model="code"
                center
                clearable
                label="验证码"
                maxlength="6"
                placeholder="请输入验证码"
                required
                :rules="[{ required: true, message: '请输入验证码' }]"
                >
                <template #button>
                    <span class="code" v-if="newTimer">{{ newCount || 0}}s重新发送</span>
                    <span class="sendcode code" v-else @click="getCode">发送验证码</span>
                </template>
            </van-field>
          </div>
          <div class="cell-box">
            <van-field
                v-model="form.CompName"
                type="text"
                name="公司"
                label="公司"
                placeholder="请输入公司"
                required
                :rules="[{ required: true, message: '请填写公司' }]"
            />
          </div>
          <div class="cell-box">
            <van-field
              readonly
              clickable
              :label="'拟参展类别'"
              :value="form.category"
              :placeholder="'请选择'"
              @click="isShow = true"
              required
              :rules="[{ required: true, message: '请选择' }]"
              />
              <van-popup v-model="isShow" position="bottom">
              <van-picker
                  show-toolbar
                  :columns="Categorys"
                  @confirm="confirm"
                  @cancel="isShow = false"
                  />
              </van-popup>
            </div>

            <div class="vant-btn">
              <van-button round block type="info"  native-type="submit">
                  保存
              </van-button>
            </div>
        </van-form>
    </div>

    <!-- 注册条款 -->
    <frame :showFrame="showFrame" @agree="showFrame = false ; checkbox = true"></frame>
     

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import frame from '../my-page/my-reg/frame';   // 条款弹框

export default {
  data() {
    return {
      form: {
        Username: "", // 姓名
        Phone: "", // 手机号
        CompName: "", // 公司名
        JobTitle: "", // 职务
        category:'',
      },
      code:'',
      count: 0,
      newCount: 0,
      timer: null,
      newTimer: null,
      pattern: /^1[3456789]\d{9}$/, // 校验手机号
      codeKey:'',
      isShow:false,
      Categorys:[], // 展品类别
      checkbox:false, // 注册表单条款
      showFrame:false, //  显示条款
    };
  },
  components:{ frame },
  computed: {
    ...mapGetters({
      user: "getUserInfo",
      categoryList:'getCategory',
      userId:"getUserId",
      exhibitionId:'getExhibitionId'
    }),
  },
  created() { 
      this.init();
  },
  methods: {
    ...mapActions({
      patchUser:'my/patchUser',
      sendCode:'my/sendCode',
      validateCode:'my/validateCode',
      addExApply:'addExApply',
      linkToExApplyFinish:'linkTo/linkToExApplyFinish'
    }),
    async init(){
      let exhibitionId = this.$route.params.id;
      this.$store.commit("setExhibitionId",exhibitionId);
      await this.$Myapollo.getCategory(this,this.exhibitionId);
      await this.$Myapollo.getUserInfo(this);
      this.categoryList.forEach(c => {
        this.Categorys.push(c.name);
      });
      // this.form.Username = this.user.nickName;
      // this.form.Phone = this.user.phone;
      // this.form.CompName = this.user.company;
      // this.form.JobTitle = this.user.jobTitle;
    },
    async onSubmit(){
      // if (!this.checkbox) {
      //     this.$toast.fail('请确认同意服务条款');
      //     return;
      // }
      let checkRes =  await this.Checkphone();
      if(checkRes) {
        let opt = {
            exhibitionId:this.exhibitionId,
            userId:this.user.userId,
            fullName:this.form.Username,
            phoneNumber:this.form.Phone,
            compName:this.form.CompName,
            categoies:this.form.category,
        }
        let data = await this.addExApply(opt);
        if(data && data.result){
          // this.$toast.success('提交成功，请耐心等待审核...');
          // // this.$Myapollo.getUserInfo(this);
          // setTimeout(()=>{
          //   this.$router.go(-1);
          // },1000)
          this.linkToExApplyFinish();
        } else {
          this.$toast.fail('提交失败');
        }
      }
    },
    confirm(e){ // 下拉菜单的选项
      this.form.category = e;
      this.isShow = false;
    },
    //手机号校验
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    // 获取手机号验证码
    async getCode(){
      console.log(this.form.Phone,'123213')
      if (!this.validatorPhone(this.form.Phone)) {
        this.$toast.fail('请输入正确的手机号')
        return;
      } else {
        this.newDownTime();
        let res = await this.sendCode({
          PhoneNumber: this.form.Phone
        });
        if (res.result) {
          this.codeKey = res.data.key;
        } else {
          this.$toast.fail('发送失败')
        }
      }
    },
    //验证手机号
    async Checkphone() {
      let res = await this.validateCode({
        key: this.codeKey,
        code: this.code
      });
      return new Promise((resolve, reject) => {
        if (res == true) {
          this.resetDown();
          resolve(true);
        } else {
          this.$toast.fail('手机号验证失败')
          this.resetDown();
          resolve(false);
        }
      })
    },


    resetDown(){ // 重置验证码
      clearInterval(this.newTimer);
      this.newCount = 0;
      this.newTimer = null;
      this.code = "";
    },

    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },
    
  },

};
</script>

<style lang="scss" scoped>
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin:.45rem 0;
  }
  .registered {
    width: 100%;
    padding-bottom: .9rem;
    .code{
        font-size: .3rem;
    }
    .sendcode{
        color: #0190fe;
    }
    .single-checkbox{
        margin:.6rem 0 .8rem .3rem;
        display: flex;
        p{
           font-size: .3rem; 
           margin-left: 5px;
           color: #666;
        }
        span{
            font-size: .3rem;
            color: #1890ff
        }
    }
    .vant-btn{
        position: fixed;
        left:0;
        bottom: 0;
        z-index: 100;
        width: 100%;
        background: #fff;
        height: .94rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 3px 0px 
        rgba(0, 0, 0, 0.2);
        .van-button--block{
            width: 6.5rem;
            height: .74rem;
            line-height: .74rem;
        }
        span{
            font-size: .3rem;
        }
    }
    }
}
.cell-box{
    margin-bottom:10px;
}
</style>